"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _aphrodite = require("aphrodite");

var _mobxReact = require("mobx-react");

var _Button = _interopRequireDefault(require("./Button"));

var _styling = require("../../toolkit/styling");

var _providers = require("../../toolkit/providers");

var _dimen = require("../../toolkit/dimen");

var _localization = require("../../toolkit/localization");

//
//  src/button/RemoveButton.tsx
//  Project-Lego
//
//  Created by Sola Ogunsakin on 1/23/19.
//  Copyright © 2019-present ContextLogic Inc. All rights reserved.
//

/* Lego Components */

/* Lego Toolkit */
var propDoc = _Button["default"].propDoc;
var demoProps = {};
var demoRender = "\n<RemoveButton onClick={() => {}} />\n";
var discussion = "\n  This component wraps [`Button`](/lego/component/Button)\n";

var RemoveButton = function RemoveButton(props) {
  var children = props.children;
  var styles = useStylesheet();

  var _useDimenStore = (0, _dimen.useDimenStore)(),
      isSmallScreen = _useDimenStore.isSmallScreen;

  var _useLocalization = (0, _localization.useLocalization)(),
      i18n = _useLocalization.i18n;

  var content = children ? children : i18n("Remove");

  if (isSmallScreen) {
    content = null;
  }

  return /*#__PURE__*/_react["default"].createElement(_Button["default"], (0, _extends2["default"])({
    padding: isSmallScreen ? "14px 12px" : "7px 18px"
  }, props), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _styling.css)(styles.root)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _styling.css)(styles.icon)
  }), content && /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _styling.css)(styles.content)
  }, content)));
};

RemoveButton.propDoc = propDoc;
RemoveButton.demoProps = demoProps;
RemoveButton.demoRender = demoRender;
RemoveButton.discussion = discussion;

var _default = (0, _mobxReact.observer)(RemoveButton);

exports["default"] = _default;

var useStylesheet = function useStylesheet() {
  var _useTheme = (0, _providers.useTheme)(),
      textDark = _useTheme.textDark;

  return (0, _react.useMemo)(function () {
    return _aphrodite.StyleSheet.create({
      root: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center"
      },
      icon: {
        height: 2,
        width: 12,
        backgroundColor: textDark
      },
      content: {
        marginLeft: 5
      }
    });
  }, [textDark]);
};